module.exports = __webpack_public_path__ + "img/default.584d56d5.svg";